import BaseAtomView from 'views/atoms/base-atom-view';
import IconTemplate from './templates/icon-atom';
import IconLoadService from 'services/loader-handler-services/icon-load-service';

const IconAtomView = BaseAtomView.extend({
  template: IconTemplate,
  initialize() {
    const { styles = null } = this.model.attributes;
    if (styles) {
      const modularStyles = `${styles['typography-color'] || ''} ${styles['size'] || ''}`;
      this.model.attributes.classes = this.model.attributes.classes
        ? `${this.model.attributes.classes} ${modularStyles}`
        : modularStyles;
    }
  },
  render() {
    const { icon, prefix = null, classes = null } = this.model.attributes;
    if (icon) {
      if (this.model.get('icon-layers')) {
        IconLoadService.stackIcons(
          [this.model.attributes, ...this.model.get('icon-layers')].map(IconLoadService.getIconFromModularJaml),
          this.model.cid
        );
      } else {
        const iconParams = IconLoadService.setPrefixAndName(icon, prefix);
        this.model.set('icon', iconParams.name);
        this.model.set('prefix', iconParams.prefix);
        IconLoadService.applyIcon(iconParams.name, this.model.cid, classes, iconParams.prefix);
      }
      BaseAtomView.prototype.render.apply(this, arguments);
    }
  },
});

export default IconAtomView;
